import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CursoInscritoModel } from 'src/app/models/curso-inscrito.model';
import { CursosService } from 'src/app/services/cursos.service';
import { AuthService } from 'src/app/_helpers';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cursos-inscrito',
  templateUrl: './cursos-inscrito.component.html',
  styleUrls: ['./cursos-inscrito.component.scss']
})
export class CursosInscritoComponent implements OnInit {
  listCursoDisp: CursoInscritoModel[] = [];
  selCursoDisp: CursoInscritoModel;
  codPersona = '';
  fecVenc: Date;
  verVisor = false;
  verVisorVideo = false;

  constructor(
    private cursoInscrito: CursosService,
    private authService: AuthService,
    private router: Router

  ) { }

  ngOnInit() {
    this.codPersona = this.authService.getusuarioJson().codPersona;
    console.log(this.codPersona);
    this.cursoInscrito.getCursosInscritos(this.codPersona).subscribe(
      data => {
        this.listCursoDisp = data['data']
        console.log(this.listCursoDisp);

      }, error => {
        console.log('Error', error);
      }

    );


  }


  onRowSelect(event) {
    console.log('select FILA', event);
// habilitar el if
    // if(event.data.estadoCurso){
      this.cursoInscrito.cursoDisp = event.data;
      this.router.navigateByUrl("/CursoDetalle");
    // }

  }

  // CursoDetalle





  formatoFecha(fecha: string) {
    this.fecVenc = new Date(fecha);
    return moment(this.fecVenc).format('DD/MM/YYYY');

  }

  getEstado(estado: boolean) {
    if (estado) {
      return 'Habilitado';
    } else {
      return 'No Habilitado';
    }
  }


  AbrirPdf() {
    // this.router.navigateByUrl("/VerDocumento");
    this.verVisor = true;


  }

  AbrirVideo() {
    this.verVisorVideo = true;

  }

}
